"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.upload = void 0;
const joi_1 = __importDefault(require("joi"));
const BusinessIds_1 = require("./BusinessIds");
const Base_1 = require("./Base");
exports.upload = {
    seriesId: BusinessIds_1.sectionBusinessId.seriesId.forbidden(),
    learnerNumber: BusinessIds_1.sectionBusinessId.learnerNumber,
    learnerUniqueId: BusinessIds_1.sectionBusinessId.learnerUniqueId.optional(),
    sectionName: Base_1.sectionBase.name.optional(),
    sectionId: BusinessIds_1.sectionBusinessId.sectionId.forbidden(),
    sectionStateId: joi_1.default.string().optional(),
    allowMultipleFiles: joi_1.default.boolean().required(),
    isAdditionalFiles: joi_1.default.boolean().optional(),
    extension: joi_1.default.string().required(),
    fileName: joi_1.default.string().required(),
    fileSize: joi_1.default.number().required(),
    errors: joi_1.default.array().items(joi_1.default.string().optional()),
};
